import { memo } from 'react';
import { IconWrapper } from 'src/modules/common/icons/IconWrapper.tsx';

export const AddProjectSelectionIcon = memo(() => (
    <IconWrapper>
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
            <path
                fill="currentColor"
                // eslint-disable-next-line max-len
                d="M2.92 12.92v-.84h5.83v.84zm0-3.34v-.83h9.16v.83zm0-3.33v-.83h9.16v.83zm10.83 10v-3.33h-3.33v-.84h3.33V8.75h.83v3.33h3.34v.84h-3.34v3.33z"
            />
        </svg>
    </IconWrapper>
));
